<template>
    <validation-observer ref="fields">
        <v-row class="pb-2 mx-0 pt-3">
            <v-col class="col-12 col-sm-12 col-md-6 col-lg-6 py-0 px-6 pt-3">
                <validation-provider name="Nome" rules="required" v-slot="{ errors }">
                    <v-text-field
                        type="text"
                        label="Nome*"
                        v-model="model['name']"
                        :error-messages="errors"
                        outlined
                        dense
                        ref="name"
                    ></v-text-field>
                </validation-provider>
            </v-col>

            <v-col class="col-12 col-sm-12 col-md-6 col-lg-6 py-0 px-6 pt-3">
                <validation-provider name="Ordine" rules="required" v-slot="{ errors }">
                    <v-text-field
                        type="number"
                        label="Ordine*"
                        v-model="model['order']"
                        :error-messages="errors"
                        outlined
                        dense
                        ref="order"
                    ></v-text-field>
                </validation-provider>
            </v-col>


            <v-col v-if="$store.getters.checkModulePermissions('checklists')" class="col-12 col-sm-12 col-md-6 col-lg-6 py-0 px-6 pt-3">
                <v-autocomplete class="font-weight-regular"
                    label="Tipo Checklist"
                    v-model="model['checklisttype_id']"
                    clearable
                    item-value="id"
                    item-text="name"
                    small-chips
                    :items="info.checklisttypes"
                    dense
                    outlined>
                </v-autocomplete>
            </v-col>                

        </v-row>

    </validation-observer>    
</template>

<script>
export default {
	name: 'shifttype-fields',
	props: {
		info: Object,
		model: Object,
	},
        
	data() {
		return {
			dialog: false,
			dialogType: null,
		}
	},
       

	computed: {

	},
        
	methods: {

		openDialog(type) {
			this.dialog = true
			this.dialogType = type
		}

	}
}
</script>

<style>

</style>